<div *ngFor="let item of items">
  <h5>{{ item.label }}</h5>
  <p>{{ item.value || "\u2014" }}</p>
</div>
